import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { IGetContractById } from './contract-control.service';

@Injectable({
    providedIn: 'root'
})

export class ContractObservableService {

    private contractDataSubject: Subject<{contractData:IGetContractById}> = new Subject<{contractData:IGetContractById}>();
    constructor () {}


    /**
     * Patch contract data
     * @param data 
     */
    sendContractData(data:{contractData:IGetContractById} ) {
        this.contractDataSubject.next(data);
    }
    
    
    
    /**
     * Get Contract data from subject
     * @returns Observable
     */
    getContractData(): Observable<{contractData:IGetContractById}> {
        return this.contractDataSubject.asObservable();
    }
}
